import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

export class SiteMapSpecialtyFilter extends Component {

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
    }

    public async init(): Promise<void> {
        let applyButton = this._element.querySelector("[data-apply-button]");
        if (applyButton) {
            applyButton.addEventListener("click", ev => this.handleMenuApply(ev));
        }
    }

    public handleMenuApply(ev: Event | null): void {
        let allSpec = this._element.querySelector("[data-all-specialty]:checked");
        let label = this._element.querySelector("#site-map-specialty-select");
        if(allSpec){
            //if all specialties just show all
            document.querySelectorAll<HTMLElement>("li[data-specialty]").forEach(function (el) {
                el.classList.remove("d-none");
            })

            if(label){
                label.textContent = "All Specialties";
            }
        } else {
            //else hide all
            document.querySelectorAll<HTMLElement>("li[data-specialty]").forEach(function (el) {
                el.classList.add("d-none");
            })

            //then show what is checked
            this._element.querySelectorAll<HTMLElement>(".specialty-checkbox:checked").forEach(function (el) {
                let specialty = el.dataset.specialty;
                if (specialty) {
                    document.querySelectorAll<HTMLElement>("li[data-specialty='" + specialty + "']").forEach(function (el) {
                        el.classList.remove("d-none");
                    })
                }

                if(label && specialty){
                    label.textContent = specialty;
                }
            });

        }
    }
}

ComponentFactory.registerComponent("SiteMapSpecialtyFilter", SiteMapSpecialtyFilter);
